module.exports = __webpack_public_path__ + "static/media/off_prepareing.0e41c5d6.svg";